
export enum UserEventType {
    Left = 'left',
    Entered = 'entered'
}
